import { render, staticRenderFns } from "./PaymentInProgress.vue?vue&type=template&id=6b2e7118&scoped=true"
import script from "./PaymentInProgress.vue?vue&type=script&lang=js"
export * from "./PaymentInProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e7118",
  null
  
)

export default component.exports